import "./product_detail.scss"

onReady(() => {
  const swiperGalleryThumbs = new Swiper(
    ".product-detail-swiper-gallery-thumbs",
    {
      spaceBetween: 15,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    }
  )
  new Swiper(".product-detail-swiper-gallery", {
    thumbs: {
      swiper: swiperGalleryThumbs,
    },
  })
})
